import { ReduxAsyncAction } from '../../../../services/ReduxAsyncAction';
import dash_api from '../../../../../main/support/dash_api';
import type { RTBHouseCredentials } from '../RTBHouse.types';

const GetRTBHouseAdAccounts = new ReduxAsyncAction<'GET_RTB_HOUSE_AD_ACCOUNTS', RTBHouseCredentials, any>(
  'GET_RTB_HOUSE_AD_ACCOUNTS'
);

GetRTBHouseAdAccounts.registerRequest((credentials: RTBHouseCredentials) => {
  return dash_api.post('/v1/rtb-house-sa/get-accounts', { credentials }).then(({ data }) => {
    return {
      accounts: data.data,
    };
  });
});

export const GET_RTB_HOUSE_AD_ACCOUNTS = GetRTBHouseAdAccounts.actionNamespaceConstants;

export const getRTBHouseAdAccounts = GetRTBHouseAdAccounts.request;
